import React from 'react';
import IcomoonReact from 'icomoon-react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import iconSet from '../../images/teambuildr-selection.json';
import { ColorGreen } from '../../GlobalStyles';

const IconRoundStyled = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  width: 22px;
  background-color: ${(props) => {
    const isCustomBackground = props.customBackground
      ? props.customBackground
      : props.theme.colors.background[1];

    return (props.transparent ? 'transparent' : isCustomBackground);
  }};
  border: ${(props) => {
    const isCustomBorder = props.customBorder
      ? (`1px solid ${props.customBorder}`)
      : (`1px solid ${props.theme.colors.iconBorder}`);
    return (
      props.noBorder
        ? (`0px solid ${props.theme.colors.iconBorder}`)
        : isCustomBorder
    );
  }};
  border-radius: 100%;
  box-sizing: border-box;
  align-self: center;
  transition: all 250ms ease-in-out;

  svg {
    path {
      fill: ${props => (props.customColor ? props.customColor : props.theme.textColor)};
    }
  }
  ${props => (
    props.complete ? `
      background-color: ${ColorGreen};
      border: 1px solid ${ColorGreen};
    ` : ''
  )}

  ${props => (
    props.light ? `
      border: 1px solid ${props.theme.buttonBorderColor2};
      svg {
        path {
          fill: rgb(172,172,172)!important;
        }
      }
    ` : ''
  )}

  ${props => (
    props.large ? `
      transform: scale(1.6)
    ` : ''
  )}
  ${props => (
    props.xLarge ? `
      transform: scale(2.3)
    ` : ''
  )}
  ${props => (
    props.jumbo ? `
      transform: scale(5)
    ` : ''
  )}
`;

const IconRound = ({
  className,
  customBackground,
  customBorder,
  customColor,
  icon,
  light,
  large,
  noBorder,
  size,
  transparent,
  xLarge,
  jumbo,
}) => (
  <IconRoundStyled
    customBackground={customBackground}
    customBorder={customBorder}
    customColor={customColor}
    noBorder={noBorder}
    light={light}
    large={large}
    xLarge={xLarge}
    jumbo={jumbo}
    className={className}
    transparent={transparent}
  >
    <IcomoonReact
      iconSet={iconSet}
      size={size}
      icon={icon}
    />
  </IconRoundStyled>
);

IconRound.propTypes = {
  customBackground: PropTypes.string,
  customBorder: PropTypes.string,
  customColor: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  noBorder: PropTypes.bool,
  light: PropTypes.bool,
  large: PropTypes.bool,
  size: PropTypes.number,
  transparent: PropTypes.bool,
  xLarge: PropTypes.bool,
};

IconRound.defaultProps = {
  customBackground: '',
  customBorder: '',
  customColor: '',
  className: 'icon',
  noBorder: false,
  light: false,
  large: false,
  size: 12,
  transparent: false,
  xLarge: false,
};

export default IconRound;
